module.exports = __webpack_public_path__ + "img/arrow.6e6d0ad2.svg";